const getters = {
  // sidebar: state => state.app.sidebar,
  // size: state => state.app.size,
  device: state => state.app.device,
  cacheData: state => state.app.cacheData,
  // visitedViews: state => state.tagsView.visitedViews,
  // cachedViews: state => state.tagsView.cachedViews,
  // token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // introduction: state => state.user.introduction,
  // roles: state => state.user.roles,
  // group: state => state.user.group,
  // permission_routes: state => state.permission.routes,
}
export default getters
